import { useEffect, useState } from 'react';
import { clientApi } from '../lib/api';

/**
 * useClientSavedAddresses
 * ------------------------------------------------------------------
 * Small hook that returns the list of addresses the currently logged-in
 * client has saved in their address book. Returns an empty array if the
 * user is not a signed-in client (401/403 silently swallowed).
 *
 * Used inside widgets to prepend a "saved addresses" picker on top of the
 * plain BAN autocomplete.
 */
export function useClientSavedAddresses() {
  const [addresses, setAddresses] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
        if (!token) {
          setReady(true);
          return;
        }
        const res = await clientApi.listAddresses();
        if (!cancelled) setAddresses(Array.isArray(res.data) ? res.data : []);
      } catch {
        // Not a client, no session, or endpoint disabled — silent.
      } finally {
        if (!cancelled) setReady(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { addresses, ready };
}

export default useClientSavedAddresses;
